/** Docs (UA): https://prostopay.atlassian.net/wiki/spaces/SW/pages/1903231001 — RefundScreen */

import { useTranslation } from 'react-i18next';
import { usePageTracking } from '../../../../shared/hooks/usePageTracking';
import { usePurchaseActions } from '../../../../shared/hooks/usePurchaseActions';
import { Button, ContentBox, ScreenTitle, ScreenWrapper } from '../../../../shared/ui';
import { FeedbackCustom } from '../../../../shared/layouts/FeedbackButtonLogic/FeedbackButtonLogic';
import { AnimatedIcon } from '../../../../shared/ui/AnimatedIcon/AnimatedIcon';
import crossAnimation from '../../../../shared/ui/AnimatedIcon/animations/cross.json';

import styles from './RefundScreen.module.css';

const RefundScreen = () => {
    const { t } = useTranslation();
    const { onRepeatPurchaseClickHandler } = usePurchaseActions();

    usePageTracking('refund');

    return (
        <ScreenWrapper>
            <ScreenTitle>{t('Failed Return')}</ScreenTitle>
            <ContentBox className={styles.animationWrapper}>
                <AnimatedIcon animationData={crossAnimation} loop={false} />

                <FeedbackCustom />
                <Button onClick={() => onRepeatPurchaseClickHandler('refund')}>
                    {t('Repeat_purchase')}
                </Button>
            </ContentBox>
        </ScreenWrapper>
    );
};

export { RefundScreen };
